<form class="form">
  <div class="input-group">
    <label>Contenu du titre ({{ componentName }})</label>
    <app-text-editor
      [(ngModel)]="sectionData.title"
      [name]="sectionData.id + 'title'"
    ></app-text-editor>
    <label>Icone</label>
    <span class="icon" *ngIf="sectionData.icon">
      <img [src]="'/titleSvgs/' + sectionData.icon" alt="icon" />
    </span>
    <button pButton (click)="displayIcons = !displayIcons" label="Choisir une icone"></button>
  </div>
  <div class="input-group">
    <label for="isAnchor">Is Anchor</label>
    <p-toggleSwitch
      id="isAnchor"
      name="isAnchor"
      [(ngModel)]="sectionData.isAnchor"
    ></p-toggleSwitch>
  </div>
</form>

<p-dialog [(visible)]="displayIcons" [style]="{ width: '60vw' }">
  <div class="modal icons">
    <div
      class="icon"
      *ngFor="let icon of titleIcons"
      [class.selected]="sectionData.icon && sectionData.icon === icon"
      (click)="selectIcon(icon)"
    >
      <img [src]="'/titleSvgs/' + icon" alt="icon" />
    </div>
  </div>
</p-dialog>
